require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-senior-ux-developer.json") })
        }
      }, "path---careers-senior-ux-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-senior-ux-developer!./.cache/json/careers-senior-ux-developer.json
// module id = 876
// module chunks = 231608221292675